import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@rekati/ui";
import { App } from "./app/App";
import { queryClient } from "./app/api";
import { I18nProvider } from "./content/i18n";
import "./styles/app.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        {/* "user": every Motion animation honours prefers-reduced-motion. */}
        <MotionConfig reducedMotion="user">
          <BrowserRouter>
            <App />
            <Toaster />
          </BrowserRouter>
        </MotionConfig>
      </I18nProvider>
    </QueryClientProvider>
  </StrictMode>,
);
